import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/shared/ui/dialog";
import { LoginForm } from "@/features/auth/components/LoginForm";

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const LoginModal = ({ isOpen, onClose }: LoginModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md bg-background border-border">
        <DialogHeader>
          <DialogTitle className="text-foreground text-xl font-semibold">
            Sign In
          </DialogTitle>
        </DialogHeader>
        <LoginForm onClose={onClose} variant="modal" />
      </DialogContent>
    </Dialog>
  );
};
